import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

// general Account Settings State
function getAccountSettingsState(state) {
  return getStateWithOnlyOneLevel(state, 'accountSettings');
}

export const getAllPublicRates = (state) =>
  getAccountSettingsState(state).get('rates');

export const getUpdateCycleWaiting = (state) =>
  getAccountSettingsState(state).get('updateCycleWaiting');

export const getPossibleCyclesForUser = (state) =>
  getAccountSettingsState(state).get('possibleCyclesForUser');

export const getPossibleCyclesForUpdateExam = (state) =>
  getAccountSettingsState(state).get('possibleCyclesForUpdateExam');

export const getUserSubscription = (state) =>
  getAccountSettingsState(state).get('userSubscription');

export const getLoadingUserSubscription = (state) =>
  getAccountSettingsState(state).get('loadingUserSubscription');

export const getEditPaymentDetailsWaiting = (state) =>
  getAccountSettingsState(state).get('editPaymentDetailsWaiting');

export const getEditPaymentDetailsSuccess = (state) =>
  getAccountSettingsState(state).get('editPaymentDetailsSuccess');

export const getEditPaymentDetailsMessage = (state) =>
  getAccountSettingsState(state).get('editPaymentDetailsMessage');

// for MyProfile state
function getMyProfileState(state) {
  return getStateWithOnlyOneLevel(state, 'myProfile');
}

export const getUpdateUsernameWaiting = (state) =>
  getMyProfileState(state).get('updateUsernameWaiting');

export const getUpdateUsernameMessage = (state) =>
  getMyProfileState(state).get('updateUsernameMessage');

export const getUpdatePersonalDataMessage = (state) =>
  getMyProfileState(state).get('updatePersonalDataMessage');

export const getFlashcardOnly = (state) =>
  getMyProfileState(state).get('flashcardOnly');

export const getUpdateProfilePrivacyWaiting = (state) =>
  getMyProfileState(state).get('updateProfilePrivacyWaiting');

export const getUpdateProfilePrivacyMessage = (state) =>
  getMyProfileState(state).get('updateProfilePrivacyMessage');

export const getSwitchPfeSkt = (state) =>
  getMyProfileState(state).get('switchPfeSkt');

export const getSwitchPfeSktMessage = (state) =>
  getMyProfileState(state).get('switchPfeSktMessage');

export const getSwitchPfeSktWaiting = (state) =>
  getMyProfileState(state).get('switchPfeSktWaiting');

export const getFlashcardWaiting = (state) =>
  getMyProfileState(state).get('updateFlashcardWaiting');

export const getFlashcardMessage = (state) =>
  getMyProfileState(state).get('updateFlashcardMessage');

export const getUpdateTimezoneWaiting = (state) =>
  getMyProfileState(state).get('updateTimezoneWaiting');

export const getUpdateTimezoneMessage = (state) =>
  getMyProfileState(state).get('updateTimezoneMessage');

export const getUpdateRateWaiting = (state) =>
  getMyProfileState(state).get('updateRateWaiting');

export const getUpdateRateMessage = (state) =>
  getMyProfileState(state).get('updateRateMessage');

export const getUpdateEmailWaiting = (state) =>
  getMyProfileState(state).get('updateEmailWaiting');

export const getUpdateEmailMessage = (state) =>
  getMyProfileState(state).get('updateEmailMessage');

export const getUpdateRatingExamWaiting = (state) =>
  getMyProfileState(state).get('updateRatingExamWaiting');

export const getUpdateRatingExamMessage = (state) =>
  getMyProfileState(state).get('updateRatingExamMessage');

export const getUpdateRatingExamSuccess = (state) =>
  getMyProfileState(state).get('updateRatingExamSuccess');

export const getUploadImageMessage = (state) =>
  getMyProfileState(state).get('uploadImageMessage');

export const getUploadImageWaiting = (state) =>
  getMyProfileState(state).get('uploadImageWaiting');

export const getUploadImageSuccess = (state) =>
  getMyProfileState(state).get('uploadingImageSuccess');

export const getUpdatePasswordWaiting = (state) =>
  getMyProfileState(state).get('updatePasswordWaiting');

export const getUpdatePasswordMessage = (state) =>
  getMyProfileState(state).get('updatePasswordMessage');

// for Disabled Questions state
function getDisabledQuestionsState(state) {
  return getStateWithOnlyOneLevel(state, 'disabledQuestions');
}

export const isLoadingResetAllSelector = (state) =>
  getDisabledQuestionsState(state).get('isLoadingResetAll');

export const isLoadingResetIndividualQuestionSelector = (state) =>
  getDisabledQuestionsState(state).get('isLoadingResetIndividualQuestion');

export const isLoadingDisabledQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('isLoadingDisabledQuestions');

export const successResetAllSelector = (state) =>
  getDisabledQuestionsState(state).get('successResetAll');

export const successResetIndividualQuestionSelector = (state) =>
  getDisabledQuestionsState(state).get('successResetIndividualQuestion');

export const successDisabledQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('successDisabledQuestions');

export const disabledQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('disabledQuestions');
export const favoriteQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('favoriteQuestions');

export const favoriteListQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('listAllFavoriteQuestions');

export const loadingFavoriteQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('loadingFavoriteQuestions');
export const loadingRemoveFavoriteQuestionsSelector = (state) =>
  getDisabledQuestionsState(state).get('loadingRemoveFavoriteQuestions');
export const disabledQuestionsCountSelector = (state) =>
  getDisabledQuestionsState(state).get('disabledQuestionsCount');
export const favoriteQuestionsCountSelector = (state) =>
  getDisabledQuestionsState(state).get('favoriteQuestionsCount');

// for active question notification from complete flash card

export const getQuestionNotificationSelector = (state) =>
  getAccountSettingsState(state).get('questionNotification');

// Customer Site Mock-up
export const getCustomerMessage = (state) =>
  getAccountSettingsState(state).get('customerMessage');

export const getCustomerSiteMockUp = (state) =>
  getAccountSettingsState(state).get('customerSiteMockUp');

// Coupon User

export const getCouponUserSelector = (state) =>
  getAccountSettingsState(state).get('coupon');
export const getApplyCouponMessageSelector = (state) =>
  getAccountSettingsState(state).get('applyCouponMessage');

export const loadApplyCouponSelector = (state) =>
  getAccountSettingsState(state).get('loadCoupon');

// Qual for daily quiz
export const getAvailableQualForDailyQuizSelector = (state) =>
  getAccountSettingsState(state).get('availableQualsForDailyQuiz');

export const getFlashSectionChoose = (state) =>
  getAccountSettingsState(state).get('flashChoose');

export const getStudySpeedSettingsMessage = (state) =>
  getAccountSettingsState(state).get('studySpeedSettingsMessage');

export const getIsLoadingStudySpeedSettings = (state) =>
  getAccountSettingsState(state).get('isLoadingStudySpeedSettings');

// Custom Sync
export const getCustomSyncSelector = (state) =>
  getAccountSettingsState(state).get('customSync');
export const getCustomSyncMessageSelector = (state) =>
  getAccountSettingsState(state).get('customSyncMessage');
export const getIsLoadingCustomSyncSelector = (state) =>
  getAccountSettingsState(state).get('isLoadingCustomSync');
export const getIsLoadingCustomSyncDataSelector = (state) =>
  getAccountSettingsState(state).get('isLoadingCustomSyncData');
